import * as Yup from 'yup'
import { NavBarLabel } from '../ResultadoIAModal'

export const resultadoIASchema = Yup.object({
  navBar: Yup.string().oneOf([
    'Diagnóstico',
    'Orientações Médicas',
    'Medicamentos',
    'Exames',
    'Atestados',
  ]) as Yup.SchemaOf<NavBarLabel>,

  diagnostico: Yup.string().when('navBar', {
    is: 'Diagnóstico',
    then: Yup.string().required('Diagnóstico obrigatório'),
    otherwise: Yup.string().notRequired(),
  }),

  orientacoes_medicas: Yup.object().when('navBar', {
    is: 'Orientações Médicas',
    then: () =>
      Yup.object({
        titulo: Yup.string().trim().required('Título é obrigatório'),
        orientacoes: Yup.string().trim().required('Orientações são obrigatórias'),
      }).required('Orientações médicas obrigatórias'),
    otherwise: () => Yup.object().notRequired(),
  }),

  receita: Yup.array().when('navBar', {
    is: 'Medicamentos',
    then: () =>
      Yup.array()
        .of(
          Yup.object({
            medicamento: Yup.string()
              .required('Medicamento é obrigatório')
              .matches(/^[^,]+$/, 'Não é permitido usar vírgula'),
            dosagem: Yup.string()
              .required('Dosagem é obrigatória')
              .matches(/^[^,]+$/, 'Não é permitido usar vírgula'),
            receituario: Yup.object().nullable().required('Receituário é obrigatório'),
            quantidade: Yup.string().required('Quantidade é obrigatória'),
            posologia: Yup.string().required('Posologia é obrigatória'),
          })
        )
        .min(1, 'Deve conter pelo menos 1 medicamento')
        .required('Receita obrigatória'),
    otherwise: () => Yup.array().notRequired(),
  }),

  exames_complementares: Yup.array().when('navBar', {
    is: 'Exames',
    then: () =>
      Yup.array()
        .of(
          Yup.object({
            exame: Yup.string()
              .required('Exame é obrigatório')
              .matches(/^[^,]+$/, 'Não é permitido usar vírgula'),
            instrucoes: Yup.string().required('Instruções é obrigatória'),
          })
        )
        .min(1, 'Deve conter pelo menos 1 exame')
        .required('Exames é obrigatório'),
    otherwise: () => Yup.array().notRequired(),
  }),

  atestados: Yup.array().notRequired(),
})
